import invoke from "../utils/invoke";

const apikey = process.env.REACT_APP_API_KEY;

export const saveTransaction = async (transactionData) => {
  const data = await invoke({
    url: `/saveTransection`,
    method: "POST",
    headers: {
      apikey,
    },
    data: transactionData,
  });
  return data;
};
export const updateTransaction = async (transactionData) => {
  const data = await invoke({
    url: `/updateTransection`,
    method: "POST",
    headers: {
      apikey,
    },
    data: transactionData,
  });
  return data;
};
export const sendTokens = async (tokenData) => {
  const data = await invoke({
    url: `/send-tokens`,
    method: "POST",
    headers: {
      apikey,
    },
    data: tokenData,
  });
  return data;
};

export const getContractInfo = async () => {
  const data = await invoke({
    url: `/getContractInfo`,
    method: "GET",
    headers: {
      apikey,
    },
  });
  return data;
};

export const getTransactionList = async (address, page) => {
  const data = await invoke({
    url: `/transactionHistory/${address}?page=${page}`,
    method: "GET",
  });
  return data;
};
export const validateCode = async (code) => {
  const data = await invoke({
    url: `promo/validate/${code}`,
    method: "GET",
    headers: {
      apikey,
    },
  });
  return data;
};

export const addTokenSold = async (tokenSold) => {
  const data = await invoke({
    url: `/addTokenSold`,
    method: "POST",
    headers: {
      apikey,
    },
    data: { tokenSold },
  });
  return data;
};

export const getTokenSold = async () => {
  const data = await invoke({
    url: `/getTokenSold`,
    method: "GET",
    headers: {
      apikey,
    },
  });
  return data;
};
